import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // If user was just passed from AuthCallback, trust it
  if (location.state?.user && !user && loading) {
    return children;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-[color:var(--hs-bg-0)] flex flex-col items-center justify-center gap-4">
        <img src="/logo.png" alt="Holdstill Records" className="h-12 w-auto opacity-80" />
        <div className="h-1 w-40 overflow-hidden rounded-full bg-white/10">
          <div className="h-full w-1/2 bg-[color:var(--hs-lime)] animate-pulse rounded-full" />
        </div>
        <p className="font-mono-ui text-xs tracking-[0.3em] uppercase text-white/50">Checking access…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/crm/login" replace />;
  }

  return children;
}
